import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "scale", "breakpoints", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled from 'styled-components';
import { pxToEm } from 'utils/ui/units';
import { createStyleFunction } from 'utils/ui/styleProps';
import ImageWithLoader from 'components/LazyImage/ImageWithLoader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var responsiveScaleProp = createStyleFunction([{
  styleProp: 'scale',
  properties: ['fontSize'],
  getValue: function getValue(value) {
    return "".concat(1 * Number(value), "rem");
  }
}]);
export var scalePresets = {
  big: {
    scale: [1.5, 2],
    breakpoints: 'm'
  }
};
/* Components */

var Wrapper = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['scale', 'breakpoints'].includes(prop);
  }
}).withConfig({
  displayName: "CircleImage__Wrapper",
  componentId: "sc-1kenrqa-0"
})(["position:relative;display:inline-block;vertical-align:middle;width:", ";height:", ";border-radius:50%;font-size:1rem;", " img{border-radius:inherit;}"], pxToEm(34), pxToEm(34), responsiveScaleProp);
function CircleImage(_ref) {
  var size = _ref.size,
    scale = _ref.scale,
    breakpoints = _ref.breakpoints,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var sizeOverrideProps = size && scalePresets[size];
  return /*#__PURE__*/_jsxs(Wrapper, _objectSpread(_objectSpread({
    scale: scale,
    breakpoints: breakpoints
  }, sizeOverrideProps), {}, {
    children: [/*#__PURE__*/_jsx(ImageWithLoader, _objectSpread({}, otherProps)), children]
  }));
}
export default CircleImage;